import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { resolveProductLink } from '../../services/catalogueApi';

// Short-link handler: a path with no `proposal` segment (e.g. /12 or /NOB-12) is treated as a
// product id / custom alias. We resolve it to the real proposal URL and redirect there.
function AliasRedirect() {
  const { alias } = useParams();
  const [status, setStatus] = useState('loading');   // 'loading' | 'notfound'

  useEffect(() => {
    let cancelled = false;

    // A bare "/proposal" (no token) isn't an alias — don't query the API with it.
    if (!alias || alias.toLowerCase() === 'proposal') {
      setStatus('notfound');
      return;
    }

    resolveProductLink(alias)
      .then((url) => {
        if (cancelled) return;
        if (url) {
          window.location.replace(url);   // full navigation — handles cross-subdomain (noble.*)
        } else {
          setStatus('notfound');
        }
      })
      .catch(() => { if (!cancelled) setStatus('notfound'); });

    return () => { cancelled = true; };
  }, [alias]);

  const wrap = {
    minHeight: '100vh', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: 14,
    fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    color: '#334155', textAlign: 'center', padding: 24,
  };

  if (status === 'notfound') {
    return (
      <div style={wrap}>
        <i className="bi bi-exclamation-circle" style={{ fontSize: 40, color: '#94a3b8' }} />
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: '#1e293b' }}>Proposal not found</h1>
        <p style={{ fontSize: 15, color: '#64748b', margin: 0, maxWidth: 420 }}>
          We couldn't find a proposal for this link. Please check the URL and try again.
        </p>
      </div>
    );
  }

  return (
    <div style={wrap}>
      <div style={{
        width: 38, height: 38, borderRadius: '50%',
        border: '4px solid #cbd5e1', borderTopColor: '#0d9488',
        animation: 'aliasspin 0.8s linear infinite',
      }} />
      <p style={{ fontSize: 15, color: '#64748b', margin: 0 }}>Redirecting…</p>
      <style>{'@keyframes aliasspin { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}

export default AliasRedirect;
